// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "@/store/store.js"
import '@/assets/css/iconfont.css'
import '@/assets/css/style.css'
import '@/assets/css/animate.css'

import 'animate.css'
import tools from "@/utils/tools.js"

// video
import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)




Vue.prototype.$webTitle = process.env.WEB_TITLE
Vue.prototype.tools = tools
Vue.prototype.$store = store

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js